// 图表的配置,详细参数解释见echart文档
export default {
  machineStatuEnum: {
    runTime: '正常生产',
    detached: '其它'
  },
  // machineStatuEnum: {
  //   runTime: '正常生产',
  //   abnormal: '异常停机',
  //   threading: '穿纱',
  //   feeding: '上料',
  //   repair: '维修',
  //   stop: '停机',
  //   detached: '离线'
  // },
  IpcStatuEnum: {
    runTime: '正常生产'
  },
  // IpcStatuEnum: {
  //   runTime: '正常生产',
  //   abnormal: '异常停机',
  //   threading: '穿纱',
  //   feeding: '上料',
  //   repair: '维修',
  //   stop: '停机'
  // },
  dataTemplate: {
    todayTime: '',
    availability: 0,
    todayLength: 0,
    runTime: 0,
    abnormal: 0,
    threading: 0,
    feeding: 0,
    repair: 0,
    stop: 0,
    detached: 0
  },
  // 机台状态对应的颜色
  machineStateColor: ['#f29100', '#19be6b', '#19be6b', '#f29100', '#f29100', '#dd6161', '#dd6161', '#dd6161',
  '#f29100', '#f29100', '#f29100', '#f29100', '#f29100', '#f29100', '#f29100', '#f29100', '#161616', '#171717', '#181818',
  '#191919', '#202020', '#212121', '#222222', '#232323', '#242424', '#252525', '#262626', '#272727', '#282828', '#292929', '#82848a'
  ],
  pieChartOption: {
    title: {
      text: '',
      // subtext: `${this.$route.params.id}`,
      left: '32%'
    },
    tooltip: {
      trigger: 'item',
      // formatter: "{a} <br/>{b} : {c}小时 ({d}%)",
      formatter: function (params) {
        return params.value + '小时' + '(' + params.percent + '%)'
      }
    },
    legend: {
      orient: 'vertical',
      left: 'right',
      data: ['穿纱', '上料', '正常生产', '停机', '维修', '异常停机', '离线', '其它'],
      right: 200
    },
    color: ['#71d5a1', '#FFFF00'],
    // color: ['#71d5a1', '#dd6161', '#E6E6FA', '#1890ff', '#FFFF00', '#f29100', '#c8c9cc'],
    series: {
      name: '机器状态',
      type: 'pie',
      radius: '55%',
      center: ['35%', '60%'],
      data: [],
      itemStyle: {
        normal: {}
      },
      label: {
        formatter: function(params) {
          return params.data.value + '小时'
        }
      }
    }
  },
  mixChartOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    // toolbox: {
    //   right: '9%',
    //   feature: {
    //     dataView: { show: true, readOnly: false },
    //     magicType: { show: true, type: ['line', 'bar'] },
    //     restore: { show: true },
    //     saveAsImage: { show: true }
    //   }
    // },
    legend: {
      data: ['生产米数', '开机率']
    },
    xAxis: [
      {
        type: 'category',
        data: [],
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        // max: function (params) {
        //   return Math.trunc(params.max * 2)
        // },
        type: 'value',
        name: '生产米数',
        axisLabel: {
          formatter: function (value) {
            return value + '米'
            // '{value} M'
          }
        }
      },
      {
        max: 100,
        splitLine: {
          show: true, // 去除网格线
          lineStyle: {
            type: 'dashed' // 设置网格线类型
          }
        },
        type: 'value',
        name: '开机率',
        axisLabel: {
          formatter: function (value) {
            return value + '%'
            // '{value} %'
          }
        }
      }
    ],
    series: [
      {
        name: '生产米数',
        type: 'bar',
        barWidth: '40%',
        data: [],
        itemStyle: {
          normal: {
            label: {
              offset: [0, 5],
              show: true, // 开启显示
              position: 'top', // 在上方显示
              textStyle: { // 数值样式
                color: 'black',
                fontSize: 16
              },
              formatter: function (params) {
                const data = params.data
                return Number(data) === 0 ? '' : data + '米'
              }
            }
          }
        }
      },
      {
        name: '开机率',
        type: 'line',
        color: '#2FC25B',
        yAxisIndex: 1,
        data: [],
        itemStyle: {
          normal: {
            label: {
              show: true,
              offset: [0, -5], // 开启显示
              position: 'top', // 在上方显示
              textStyle: { // 数值样式
                color: 'black',
                fontSize: 16
              },
              formatter: function (params) {
                const data = params.data
                return Number(data) === 0 ? '' : data + '%'
              }
            }
          }
        }
      }
    ]
  }
}
